// extracted by mini-css-extract-plugin
module.exports = {"root":"LoaderPageWeb_root__soYIx"};